import { APIGATEWAY_BASE_URL } from 'src/dataLayer/env';
import makeAjaxRequest from 'src/dataLayer/remoteData/babbelAPI/makeAjaxRequest';
import { NO_CAPTCHA_REQUIRED_STATUS } from 'src/dataLayer/localData/captcha.js';

export const ERROR_KEYS = {
    422: {
        key: 'common.error.unknown'
      },
    400: {
        key: 'common.error.unknown'
    },
    default: {
      key: 'common.error.unknown'
    }
  };

const getPayload = ({
  email,
  captchaResponseToken
}) => {
  const payload  = {
    account: {
        email,
        captcha: {
            token: captchaResponseToken === NO_CAPTCHA_REQUIRED_STATUS ? '' : captchaResponseToken
        }
    }
  };
  return payload;
};

export default (props) =>
  makeAjaxRequest({
    verb: 'POST',
    payload: getPayload(props),
    url: `${APIGATEWAY_BASE_URL}/v1.0.0/${props.locale}/authentication/magic_link`,
    errorKeys: ERROR_KEYS
  })
  .then((response) => response)
  .catch((error) => ({ error }));
